import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// 引入element-ui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import header from './components/header.vue'
import nav from './components/nav.vue'
import footer from './components/footer.vue'
import login from './components/login.vue'




Vue.component('myHeader',header)
Vue.component('myNav',nav)
Vue.component('myFooter',footer)
Vue.component('login',login)
Vue.use(login);
//2.导入axios
import axios from "axios";
//(3)将axios挂载到Vue构造函数原型中
Vue.prototype.$axios = axios;



// 引入 Base64
import { Base64 } from "js-base64";
Vue.prototype.$Base64 = Base64;
// Vue.prototype.$encode = Base64.encode
// Vue.prototype.$decode = Base64.decode
//  引入Echarts
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
